import React from 'react';
import { Box, Button, ExternalLinkIcon, Link, Text } from '@razorpay/blade/components';
import { EmptyListView } from 'components/ui/EmptyListView/EmptyListView';
import { helpArticles } from '../constants';
import { useFilters } from 'hooks/useFilters';

interface EmptyStateProps {
  onCreateClick: () => void;
}

const SalaryStructuresListEmptyStateView: React.FC<EmptyStateProps> = ({ onCreateClick }) => {
  const { isAnyFilterApplied, currentFilters, getSelectedFiltersCount } = useFilters({
    filtersMap: {
      status: 'status',
      search: 'search',
    },
  });

  const isStatusFilterApplied = ['', 'all'].includes(currentFilters.status);
  const showShowCreateFirstSalaryStructureText =
    isStatusFilterApplied && getSelectedFiltersCount(currentFilters, ['status']) === 0;

  return (
    <EmptyListView
      title={isAnyFilterApplied ? 'No Search Results Found' : ' No Salary Structures created yet'}
      description={
        showShowCreateFirstSalaryStructureText ? (
          <Text color="surface.text.gray.muted" weight="medium" textAlign="center">
            Click on Create Structure button to create your first salary structure
          </Text>
        ) : null
      }>
      <Box display="flex" flexDirection="column" gap="spacing.4" marginX="auto">
        <Link
          size="medium"
          variant="anchor"
          href={helpArticles.learnMore}
          icon={ExternalLinkIcon}
          iconPosition="right"
          target="_blank">
          Learn more about salary structures
        </Link>
        <Box marginX="auto">
          <Button size="medium" onClick={onCreateClick} isFullWidth>
            Create Salary Structure
          </Button>
        </Box>
      </Box>
    </EmptyListView>
  );
};

export default SalaryStructuresListEmptyStateView;
